exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-panel-header-click {\n  cursor: pointer;\n}\n.uu5-bricks-panel-glyphicon {\n  float: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/panel-header.less
// module id = 248
// module chunks = 0